import { render, staticRenderFns } from "./StudentsIdReportFilter.vue?vue&type=template&id=263b3b2e&"
import script from "./StudentsIdReportFilter.vue?vue&type=script&lang=js&"
export * from "./StudentsIdReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports